/* tslint:disable */
/* eslint-disable */
/**
 * Rooming_API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Athlete,
    AthleteFromJSON,
    AthleteFromJSONTyped,
    AthleteToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchResult
 */
export interface SearchResult {
    /**
     * 
     * @type {Array<Athlete>}
     * @memberof SearchResult
     */
    athletes?: Array<Athlete> | null;
    /**
     * 
     * @type {number}
     * @memberof SearchResult
     */
    count?: number;
}

export function SearchResultFromJSON(json: any): SearchResult {
    return SearchResultFromJSONTyped(json, false);
}

export function SearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'athletes': !exists(json, 'athletes') ? undefined : (json['athletes'] === null ? null : (json['athletes'] as Array<any>).map(AthleteFromJSON)),
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}

export function SearchResultToJSON(value?: SearchResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'athletes': value.athletes === undefined ? undefined : (value.athletes === null ? null : (value.athletes as Array<any>).map(AthleteToJSON)),
        'count': value.count,
    };
}

